module.exports = __webpack_public_path__ + "img/unchecked.41b4e0fb.svg";